(ns manage.adset.modal.hooks
  (:require ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.form :as form]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as q]
            [common.resource.query.social-settings :as social-settings]
            [common.util :as util]
            [malli.core :as m]
            [manage.adset.business-logic :as business-logic]
            [manage.adset.util :as adset-util]
            [re-frame.core :as rf]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(def schema
  (m/schema
   [:map
    [:name
     [:string {:min 1 :max 150
               :error/fn (fn [{:keys [value]} _]
                           (cond
                             (str/blank? value) "Please input adset name"
                             (> (count value) 150) "Name can not be longer than 150 characters"
                             :else nil))}]]
    [:plannedDates
     [:fn {:error/message "Please select a start and end date"}
      (fn [[plannedStart plannedEnd :as value]]
        (and (some? plannedStart)
             (some? plannedEnd)))]]
    [:targetImpressions
     [number? {:error/message "Please input expected amount of impressions"}]]
    [:autoApproveAdVariants {:optional true} boolean?]]))

(defhook use-auto-settings [{:keys [advertiser-id adset-id channel]}]
  (let [automated-activation? (use-flag :automated-activation)
        {:keys [data]} (use-query
                        (social-settings/fetch-advertiser-adset-integration-settings
                         {:advertiser-id advertiser-id
                          :adset-id adset-id
                          :channel channel
                          :enabled automated-activation?}))
        {put-settings :mutate} (use-mutation
                                (social-settings/save-integration-settings-mutation
                                 {:advertiser-id advertiser-id
                                  :adset-id adset-id
                                  :channel channel}))]
    {:auto-enable  (:auto-enable data)
     :auto-publish (:auto-publish data)
     :save-fn      (fn [overrides] (put-settings (merge data overrides)))}))

(defhook use-edit-form [{:keys [channel id advertiserId] :as adset}]
  (let [automated-activation? (use-flag :automated-activation)
        {:keys [auto-enable auto-publish save-fn]} (use-auto-settings
                                                    {:advertiser-id advertiserId
                                                     :adset-id id
                                                     :channel channel})
        form-resolver (form/use-malli-resolver schema)
        {:keys [handleSubmit control]}
        (form/use-form #js {:mode "onBlur"
                            :values (->js (-> adset
                                              (select-keys [:name :targetImpressions :autoApproveAdVariants])
                                              (assoc :plannedDates [(:plannedStart adset)
                                                                    (:plannedEnd adset)]
                                                     :autoEnable auto-enable
                                                     :autoPublishing auto-publish)))
                            :resolver form-resolver})
        current-auto-enable  (rhf/useWatch #js {:name "autoEnable"     :control control})
        current-auto-publish (rhf/useWatch #js {:name "autoPublishing" :control control})
        {patch-adset :mutate} (use-mutation (q/patch-adset-mutation {:adset-id (:id adset)}))]
    {:on-submit (handleSubmit (fn [^js form-data]
                                (when automated-activation?
                                  (save-fn {:auto-enable  current-auto-enable
                                            :auto-publish current-auto-publish}))
                                (let [form-data' (->clj form-data)
                                      [plannedStart plannedEnd] (:plannedDates form-data')
                                      payload (-> form-data'
                                                  (select-keys [:name :targetImpressions :autoApproveAdVariants])
                                                  (assoc :plannedStart (util/format-iso-string plannedStart "YYYY-MM-DD")
                                                         :plannedEnd (util/format-iso-string plannedEnd "YYYY-MM-DD")))]
                                  (patch-adset payload
                                               #js {:onSuccess #(rf/dispatch [:modal/close])}))))
     :control control}))

(defhook use-channel-options []
  (let [tiktok-enabled? (use-flag :tiktok-channel)
        youtube-enabled? (use-flag :youtube-with-ad-variants)]
    (cond->> adset-util/channel-options
      (not tiktok-enabled?) (remove (fn [{:keys [value]}]
                                      (= value "tiktok")))
      (not youtube-enabled?) (remove (fn [{:keys [value]}]
                                       (= value "youtube"))))))

(defhook use-workflow-options []
  (let [channel (use-subscribe [:form.adset-create/value [:channel]])
        ctv-with-ad-variants-enabled? (use-flag :ctv-with-ad-variants)
        legacy-workflows-enabled? (use-flag :legacy-workflows)
        workflows (get-in business-logic/channels [(keyword channel) :workflows])
        workflow-entries
        (cond->> workflows
          (not legacy-workflows-enabled?) (filter (comp #{:ad-variants} first))
          (and legacy-workflows-enabled? (= (keyword channel) :ctv) (not ctv-with-ad-variants-enabled?))
          (remove (comp #{:ad-variants} first)))]
    (map (fn [[key m]] (assoc m :value (name key))) workflow-entries)))
